// extracted by mini-css-extract-plugin
export default {"row":"UserInfoItem_row__Mci+4","label":"UserInfoItem_label__291+s","value":"UserInfoItem_value__BroPt"};